import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { checkTagValidity, months, years } from "../../Utils/Utils";
import { DEGELER_POSTPAID, LIST_RDV } from "../../Utils/constant";
import { Abonnement } from "../../components/Abonnement/Abonnement";
import { AbonnementRendezVous } from "../../components/Abonnement/AbonnementRendezVous";
import { Calendar } from "../../components/Icons/Calendar";
import { DetailRdv } from "../../components/Rendez-vous/DetailRdv";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Tabs } from "../../components/Widget/Tab";
import { store } from "../../services/service";
import { useStoreApp } from "../../store/storeApp";
const IntentionRdv = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: 0,
    assigne: false,
    value: "En attente de prise de rendez-vous de survey",
    tag: "LISTE_EN_ATTENTE_RDV_SURVEY",
  });
  const [selectIntention, setSelectIntention] = useState(null);

  const intentions = useStoreApp();
  useEffect(() => {
    intentions.getData(
      LIST_RDV,
      { page: 0, param: "", size: 6 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=",
    );
  }, []);

  const degelerRdv = async (id) => {
    await store(`${DEGELER_POSTPAID}/${id}`, "application/json", {}).then(
      (res) => {
        if (res.status === 200) {
          intentions.getData(
            LIST_RDV,
            { page: 0, param: "", size: 6 },
            "&periode=&mois=&annee=&dateDebut=&dateFin=",
          );
        }
      },
    );
  };

  const more = (page) => {
    intentions.getData(
      LIST_RDV,
      { page: page - 1, param: "", size: 6 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=",
    );
  };
  const listeTabsData = [
    {
      index: 0,
      step: false,
      value: "En attente de prise de rendez-vous de survey",
      tag: "LISTE_EN_ATTENTE_RDV_SURVEY",
    },
    // {
    //   index: 1,
    //   step: false,
    //   value: "En attente de prise de rendez-vous de raccordement",
    //   tag: "LISTE_EN_ATTENTE_RDV_RACCORD",
    // },
    { index: 2, step: true, value: "Rendez-vous programmés", tag: "LISTE_RDV" },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="text-3xl font-bold font-mtn">Rendez-vous</h3>
        <div className="ml-auto flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select
              onChange={(e) => {
                intentions.getData(
                  LIST_RDV,
                  { page: 0, param: "", size: 6 },
                  `&periode=${select}&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
                );
              }}
              className="my-2 select"
            >
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select
              onChange={(e) => {
                intentions.getData(
                  LIST_RDV,
                  { page: 0, param: "", size: 6 },
                  `&periode=ANNEE&mois=&annee=${e.target.value}&dateDebut=&dateFin=`,
                );
              }}
              className="my-2 select "
            >
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                  intentions.getData(
                    LIST_RDV,
                    { page: 0, param: "", size: 6 },
                    `&periode=JOUR&mois=&annee=&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}`,
                  );
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>
      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {active.tag === "LISTE_EN_ATTENTE_RDV_SURVEY" ? (
          <Abonnement
            status={"EN_ATTENTE_DE_RENDEZ_VOUS"}
            step={5}
            perm={"POURSUIVRE_RDV_SURVEY"}
          />
        ) : active.tag === "LISTE_EN_ATTENTE_RDV_RACCORD" ? (
          <AbonnementRendezVous
            status={"EN_ATTENTE_DE_RENDEZ_VOUS_DE_RACCORDEMENT"}
            perm={"POURSUIVRE_RDV_RACCORDEMENT"}
            step={7}
          />
        ) : active.tag === "LISTE_RDV" ? (
          <>
            <div>
              <input
                onChange={(e) => {
                  intentions.getData(
                    LIST_RDV,
                    { page: 0, param: `${e.target.value}`, size: 6 },
                    "&periode=&mois=&annee=&dateDebut=&dateFin=",
                  );
                }}
                type="text"
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-10">
                {intentions?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <img src="" alt="" srcset="" />
                    <p>Aucune donnee</p>
                  </div>
                ) : intentions?.data?.data?.length !== 0 &&
                  !intentions?.loading ? (
                  intentions?.data?.data?.map((item) => (
                    <div className="relative bg-white rounded-xl border-slate-200 border shadow-md">
                      <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                        <p className="text-[12px] font-semibold">
                          N°{item?.abonnement.eligibilite?.numeroTicket}
                        </p>
                      </div>
                      <div className=" px-3 py-2 ">
                        <div className="items-center gap-2 space-y-3">
                          {item?.status === "TERMINER" &&
                          item.listRendezVous.find(
                            (e) => e.status === item.status,
                          ) ? (
                            <div className="flex gap-2">
                              <p className="text-xs border border-dotted text-green-900 px-1 border-green-600 bg-green-50 rounded py-[2px]">
                                {item.listRendezVous
                                  .find((e) => e.status === item.status)
                                  ?.status.toLowerCase()
                                  .replace(/_/g, " ")}
                              </p>
                              <p className="text-xs border border-dotted text-red-900 px-1 border-red-600 bg-red-50 rounded py-[2px]">
                                resultat :{" "}
                                {item.listRendezVous
                                  .find((e) => e.status === item.status)
                                  ?.resultat.toLowerCase()
                                  .replace(/_/g, " ")}
                              </p>
                            </div>
                          ) : null}
                          <Pbo
                            pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                            port={item?.brin}
                          />

                          <div className="flex gap-1 my-3">
                            <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                            <div>
                              <p className="text-[13px] font-medium">
                                {item?.abonnement?.client?.nomPrenoms}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                <span>{item?.abonnement?.client?.numero}</span>{" "}
                                {" | "}{" "}
                                <span>
                                  {item?.abonnement?.client?.secondNumero}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                          <h1 className="text-xs flex gap-1 items-center my-2">
                            Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                            {item?.abonnement?.forfait?.categorie
                              ?.replace("_", "")
                              .toLowerCase()}
                          </h1>

                          <div className=" gap-1 ">
                            <div>
                              <p className="text-[13px] font-medium">
                                Numero FTTH : {item?.abonnement?.numeroFtth}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                SN :{" "}
                                <span>{item?.abonnement?.numeroSerie}</span>
                              </p>
                            </div>
                          </div>

                          <h1 className="text-xs flex gap-1 items-center my-2">
                            <AvatarIcon />
                            Equipe en charge : {item?.equipe?.designation}
                          </h1>
                          <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon />
                              {item?.typeRdv?.toLowerCase()} : {item?.dateRdv}
                            </p>
                          </div>

                          <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <HomeIcon />
                              {item?.abonnement?.batiment?.designation}
                            </p>
                            <p className="text-xs flex gap-1 font-medium">
                              <ArchiveIcon />{" "}
                              {item?.abonnement?.equipement?.designation}{" "}
                            </p>
                          </div>
                        </div>
                        <h1 className="text-[14px] font-bold flex items-center">
                          <SewingPinFilledIcon />
                          {item?.abonnement?.commune +
                            ", " +
                            item?.abonnement?.quartier}
                        </h1>
                        {checkTagValidity("DETAILS_RENDEZVOUS") ? (
                          <button
                            onClick={() => {
                              setSelectIntention(item);
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="my-2 btn btn-sm bg-main text-xs"
                          >
                            Details du rendez-vous
                          </button>
                        ) : null}
                      </div>

                      <dialog
                        id={`show${item.id}`}
                        className="modal bg-slate-900/70"
                      >
                        <div className="modal-box">
                          <div className="flex items-center justify-between p-3">
                            <div className="flex flex-row gap-2">
                              <div className=" flex justify-center items-center rounded-full bg-[#ffcb05] w-8 h-8">
                                <Calendar />
                              </div>
                              <h2 className="font-extrabold flex flex-row items-center text-sm text-[#000000a8]">
                                Details d'intention
                              </h2>
                            </div>

                            {item?.abonnement?.client?.typeClient ===
                              "ENTREPRISE_POSTPAID" && (
                              <button className="btn btn-sm bg-main text-xs">
                                Degeler le rendez-vous
                              </button>
                            )}

                            <form method="dialog">
                              <button
                                id="fermer_create_trajet"
                                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                              >
                                ✕
                              </button>
                            </form>
                          </div>
                          <DetailRdv item={item} />
                        </div>
                      </dialog>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
              </div>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={intentions?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default IntentionRdv;
